import { createSlice } from "@reduxjs/toolkit";
import { createUSerSession } from "../actions/quickSightDashboard.action";

const initialState = {
  isLoading: false,
  data: null,
};

const createUserDashboardSessions = createSlice({
  name: "Create Dashboard Sessions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(createUSerSession.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(createUSerSession.fulfilled, (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    });

    builder.addCase(createUSerSession.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export default createUserDashboardSessions.reducer;
